var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49863 8.28404C4.06556 7.85097 4.06556 7.14936 4.49863 6.71618L8.93357 2.28135C9.36664 1.84828 10.0683 1.84828 10.5014 2.28135C10.9346 2.71442 10.9345 3.41603 10.5014 3.84921L6.85037 7.50027L10.5014 11.1513C10.9345 11.5844 10.9345 12.286 10.5014 12.7192C10.2849 12.9357 10.0012 13.0441 9.71756 13.0441C9.43394 13.0441 9.15022 12.9357 8.93368 12.7192L4.49863 8.28404Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.3b6f2c859aee022e8d1a79a415d7eb96.svg";
export { ForwardRef as ReactComponent };